import React, { Fragment, useState } from 'react';
import { Popover } from '@headlessui/react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { formatContentfulComponentProps } from '../../../../../../utils/globals';
import { IBlock } from '../../../../../../utils/types/contentful';
import { FlyoutPopover } from '../../../../Overlays/Flyout';
import { DesktopNavigationDetails } from './Details/desktopNavigationDetails';
import { TabListItem } from '../../../../Navigation/Tabs/Tab';
import { Link } from '../../../../Elements/Link';

interface HeaderNavigationProps {
  navigations: IBlock;
}

export const DesktopHeaderNavigation = ({
  navigations,
}: HeaderNavigationProps) => {
  const [selectedTab, setSelectedTab] = useState(null);
  const returnTabs = () => {
    const { list } = formatContentfulComponentProps(navigations);
    return list?.items.map((item, key) => {
      const { link, details, color } = formatContentfulComponentProps(item);
      // navigation has details, then render a fly out popopver with navigation details
      if (details) {
        return (
          <div
            onMouseEnter={() => setSelectedTab(key)}
            onMouseLeave={() => setSelectedTab(null)}>
            <TabListItem
              selected={selectedTab === key}
              color={color}>
              <FlyoutPopover
                bgColor={color?.classname === 'black' && color}
                handleClose={() => setSelectedTab(null)}
                button={() => (
                  <button
                    type='button'
                    className='flex outline-none h-full items-center z-40 max-w-xs hover:text-black'
                    onClick={() => {
                      setSelectedTab(key);
                    }}>
                    <Label
                      {...link?.label}
                      truncate
                      size='base'
                      weight='normal'
                    />
                  </button>
                )}>
                <DesktopNavigationDetails
                  color={color}
                  details={details}
                />
              </FlyoutPopover>
            </TabListItem>
          </div>
        );
      } else {
        return (
          <div
            onMouseEnter={() => setSelectedTab(key)}
            onMouseLeave={() => setSelectedTab(null)}>
            <TabListItem
              selected={selectedTab === key}
              color={color}>
              <Link {...link} />
            </TabListItem>
          </div>
        );
      }
    });
  };

  return (
    <Popover.Group as={Fragment}>
      <div className='h-full sm:flex sm:justify-center sm:space-x-8'>
        {returnTabs()}
      </div>
    </Popover.Group>
  );
};
